/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.revealFollowUpInfo = () => $('#follow_up').on('change', () => $('.follow-up').toggle());

/*
$(() => revealFollowUpInfo());
*/

function initFollowUpInfoOnLoad() {
  if ($('#follow_up').length) {
    revealFollowUpInfo();
  }
}

$(initFollowUpInfoOnLoad);
document.addEventListener('turbo:load', initFollowUpInfoOnLoad);
